import { createFileRoute } from '@tanstack/react-router'
import { CrewsPage } from '@/features/crews/CrewsPage'
import { requireNav } from '@/nav/guard'

export const Route = createFileRoute('/_app/crews')({
  beforeLoad: requireNav('crews'),
  component: CrewsPage,
})
